const newsletterApiFactory = (axios) => ({
  newsletterSignup: (params) => axios.post('/newsletter/signup', params),
});

export { newsletterApiFactory };
